export default __webpack_public_path__ + "static/media/results.9ad2f714.png";